import BugReportSimpleQuestion from "./BugReportSimpleQuestion";
import * as theme from "../theme";

// Adapted from LargeString.jsx

const BugReportLargeString = ({ text, onInput, fieldId, minHeight, value }) => {
  return (
    <BugReportSimpleQuestion
      leftString={text}
      alignCenter={"No"}
      rightComponent={
        <textarea
          type="text"
          id={"stringInput" + fieldId}
          style={{
            ...theme.inputStyle,
            minHeight: minHeight,
            width: theme.inputStyle.width,
          }}
          onChange={onInput}
          value={value}
        ></textarea>
      }
    ></BugReportSimpleQuestion>
  );
};

export default BugReportLargeString;
